module.exports = __webpack_public_path__ + "img/high-west-praire-dash-full-logo.b812476e.png";